module.exports = "/images/elo.svg?d01839a75ed59caafe77708185910658";